import { toast } from "@skylead/component-library"

import ACTIONS from "../../constants/ACTIONS"
import listService from "../../services/list-service"

function getAllListsSuccess(list) {
  return { type: ACTIONS.GET_ALL_LISTS, payload: { ...list } }
}

function getAllLists(options = {}) {
  return async (dispatch, getState) => {
    try {
      const seatId = getState().account.activeAccountID
      const queryParams = new URLSearchParams()

      queryParams.append("seatId", seatId)

      if (options.search) queryParams.append("search", options.search)
      if (options.skip !== undefined) queryParams.append("skip", options.skip)
      if (options.take !== undefined) queryParams.append("take", options.take)
      if (options.direction) queryParams.append("direction", options.direction)

      const query = `?${queryParams.toString()}`

      const response = await listService.getAllLists(query)
      const list = response.data.data

      dispatch(getAllListsSuccess(list))
    } catch (error) {}
  }
}

function deleteLists(listIds) {
  return async () => {
    try {
      await listService.deleteLists(listIds)
      return true
    } catch (error) {
      return false
    }
  }
}

function exportList(tt, { id, name } = {}) {
  return async () => {
    try {
      // TODO PP@Any: Add export-started key (value: "Your export has started.") to translation-ms
      toast.info(tt("export-has-started"))

      const response = await listService.exportList(id)

      const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }))
      const link = document.createElement("a")

      link.href = url
      link.setAttribute("download", `${name || "prospects"}-${Date.now()}.csv`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      // TODO PP@Any: Add export-completed-successfully key (value: "Your export is done.") to translation-ms
      toast.success(tt("export-is-done"))
    } catch (error) {
      // TODO PP@Any: Add export-failed key (value: "Your export failed.") to translation-ms
      toast.error(tt("export-failed"))
    }
  }
}

export { getAllLists, deleteLists, exportList }
